import { useQuery } from 'react-query';

import { getClusterType as queryFn } from 'api/endPoints/getClusterType';

export const useQueryGetNlpThresholds = (params) => {
    return useQuery(['getNlpThresholds', params], () => queryFn(params), {
        enabled: Boolean(params.projectId),
    });
};
